import * as io from "io-ts";

export const ContestEmbedResolver = io.type({
  call_letters: io.string,
  contest_id: io.number,
  url: io.string,
});

export type ContestEmbedInterface = io.TypeOf<typeof ContestEmbedResolver>;
